module.exports = __webpack_public_path__ + "static/media/ankh.1f026abc.svg";